import React, { useEffect, useState } from 'react'
import { material } from '../../../library/material';
import { useTheme } from '@mui/material';
import Navbar from '../../navbar/Navbar';
import { StyledTableCell } from '../../../shared/TableHeaderStyle';
import { useNavigate } from 'react-router-dom';
import Snackbar from '../../toastrmessage/Snackbar';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import moment from 'moment';
import { connect } from 'react-redux';
import { getAllCrmData } from '../../../services/PlatformCrmService';
import AddPlatFormCrmDetails from './AddPlatFormCrmDetails';
import AddPlatFormCrm from './AddPlatFormCrm';
import ViewSentMailData from './ViewSentMailData';
import ViewReceiveMailData from './ViewReceiveMailData';
import ViewNotesDialog from './ViewNotesDialog';
import 'react-loading-skeleton/dist/skeleton.css'



function PlatFormCrmDetails(props) {

    const { userData, clinicData } = props;
    const userDetails = userData.authReducer.data;
    const clinicDetails = clinicData.clinicReducer.data;
    const theme = useTheme();
    // const navigate = useNavigate();
    const [openAddCrm, setOpenAddCrm] = useState(false);
    const [openViewSentEmail, setOpenViewSentEmail] = useState(false);
    const [openViewReceiveEmail, setOpenViewReceiveEmail] = useState(false);
    const [allCrm, setAllCrm] = useState([]);
    const [openEditCrm, setOpenEditCrm] = useState({ action: false, data: null });
    const [openSnackBar, setOpenSnackBar] = useState({
        "action": false,
        "type": "",
        "message": "",
    });
    const [filteredCrm, setFilteredCrm] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [openNotesDialog, setOpenNotesDialog] = useState({ action: false, rowData: null });
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(0);
    const [totalElements, setTotalElements] = useState(0);
    const [statusValue, setStatusValue] = useState('All Data');

    useEffect(() => {
        getCrmData();
    }, [statusValue]);

    const handleChangeStatus = (event) => {
        setStatusValue(event.target.value);
    };

    const getCrmData = (paginationData) => {
        setIsLoading(true);
        const param = {
            orgId: userDetails.orgId,
            limit: paginationData ? paginationData.limit : 10,
            page: paginationData ? paginationData.page : 0,
            search: paginationData ? paginationData.search : "",
            status: statusValue == "All Data" ? "" : statusValue
        }
        getAllCrmData(param)
            .then((resp) => {
                setAllCrm(resp.data.data);
                setFilteredCrm(resp.data.data);
                setPage(Number(resp.data.pagination.page));
                setRowsPerPage(resp.data.pagination.limit);
                setTotalElements(resp.data.pagination.total);
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error)
                setOpenSnackBar({
                    "action": true,
                    "type": "error",
                    "message": error.response.data?.data,
                })
            })
    };

    const addCrm = () => {
        setOpenAddCrm(true);
    };

    const addCrmNormalData = () => {
        setOpenEditCrm({ action: true, data: null });
    };

    const editCrmData = (rowData) => {
        setOpenEditCrm({ action: true, data: rowData });
    };
    const viewSentEmail = () => {
        setOpenViewSentEmail(true);
    };
    const viewReceiveEmail = () => {
        setOpenViewReceiveEmail(true);
    };

    const filterByField = (searchValue) => {
        const payload = {
            search: searchValue
        }
        getCrmData(payload)
    };

    const viewCrmNote = (rowData) => {
        setOpenNotesDialog({ action: true, rowData: rowData })
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        const payload = {
            limit: rowsPerPage,
            page: newPage,
        }
        getCrmData(payload)
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event.target.value);
        const payload = {
            limit: event.target.value,
            page: page
        }
        getCrmData(payload)
    };

    return (
        <material.Grid className='container-fluid'
            sx={{
                [theme.breakpoints.down('sm')]: {
                    mt: 13
                },
                [theme.breakpoints.up('sm')]: {
                    mt: 12
                },
                [theme.breakpoints.up('md')]: {
                    mt: 12
                },
                [theme.breakpoints.up('lg')]: {
                    mt: 12
                },
            }}
        >
            <Navbar />
            <div className='row'>
                <div className='col-xs-12 col-sm-4 col-md-2 col-lg-2 mt-2'>
                    <material.TextField
                        fullWidth
                        variant="standard"
                        label="Search CRM list"
                        type='text'
                        sx={{ mt: -2 }}
                        onChange={(e) => filterByField(e.target.value)}
                    />
                </div>
                <div className="col-xs-12 col-sm-4 col-md-2 col-lg-2 mt-2">
                    <material.FormControl variant="standard" fullWidth sx={{ mt: -2 }}>
                        <material.InputLabel id="demo-simple-select-standard-label">Filter by Status</material.InputLabel>
                        <material.Select
                            label="Status"
                            labelId="demo-simple-select-standard-label"
                            id="demo-simple-select-standard"
                            fullWidth
                            value={statusValue}
                            onChange={handleChangeStatus}
                        >
                            <material.MenuItem value={"All Data"}>All Data</material.MenuItem>
                            <material.MenuItem value={"Interested"}>Interested</material.MenuItem>
                            <material.MenuItem value={"Present Demo"}>Present Demo</material.MenuItem>
                            <material.MenuItem value={"Onboarding"}>Onboarding</material.MenuItem>
                            <material.MenuItem value={"In Transit"}>In Transit</material.MenuItem>
                            <material.MenuItem value={"Customer"}>Customer</material.MenuItem>
                        </material.Select>
                    </material.FormControl>
                </div>
                <div className='col-xs-12 col-sm-4 col-md-8 col-lg-8 mt-2'>
                    <material.Stack direction='row' spacing={1} justifyContent='flex-end'>
                        <material.Button variant="contained" sx={{ textTransform: "none", mr: 1 }} size='small' onClick={viewSentEmail}>View Sent Email</material.Button>
                        <material.Button variant="contained" sx={{ textTransform: "none", mr: 1 }} size='small' onClick={viewReceiveEmail}>View Receive Email</material.Button>
                        <material.Button variant="contained" sx={{ textTransform: "none", mr: 1 }} size='small' onClick={addCrmNormalData}>Add CRM Data</material.Button>
                        <material.Button variant="contained" sx={{ textTransform: "none", mr: 1 }} size='small' onClick={addCrm}>Add CRM Excel Data</material.Button>
                    </material.Stack>
                </div>
                <div className="col-12 mt-3">
                    <material.Paper sx={{ width: '100%', overflow: 'hidden', p: 3 }}>
                        <material.TableContainer>
                            <material.Table>
                                <material.TableHead >
                                    <material.TableRow>
                                        <StyledTableCell>CRM Name</StyledTableCell>
                                        <StyledTableCell>Clinic Name</StyledTableCell>
                                        <StyledTableCell>Website</StyledTableCell>
                                        <StyledTableCell>Nurse Name</StyledTableCell>
                                        <StyledTableCell>Email</StyledTableCell>
                                        <StyledTableCell>Linkedin</StyledTableCell>
                                        <StyledTableCell>Address</StyledTableCell>
                                        <StyledTableCell>Mobile Number</StyledTableCell>
                                        <StyledTableCell>FaceBook</StyledTableCell>
                                        <StyledTableCell>TikTok</StyledTableCell>
                                        <StyledTableCell>Instagram</StyledTableCell>
                                        <StyledTableCell>Interested Product</StyledTableCell>
                                        {/* <StyledTableCell>Others Interested Product</StyledTableCell> */}
                                        <StyledTableCell>Status</StyledTableCell>
                                        <StyledTableCell>Next Follow Up Data</StyledTableCell>
                                        <StyledTableCell>Email Sent Date</StyledTableCell>
                                        <StyledTableCell>Notes</StyledTableCell>
                                    </material.TableRow>
                                </material.TableHead>
                                <material.TableBody>
                                    {isLoading ? (
                                        <material.TableRow >
                                            <material.TableCell colSpan={18}>
                                                <SkeletonTheme baseColor="#bbdefb" highlightColor="#c6ff00" enableAnimation="true" inline="true" width="100% " height="30px">
                                                    <Skeleton count={18} />
                                                </SkeletonTheme>
                                            </material.TableCell>
                                        </material.TableRow>
                                    ) : (
                                        <>
                                            {filteredCrm.length ? filteredCrm.map((row, k) => (
                                                <material.TableRow key={k}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: "pointer", ":hover": { backgroundColor: "lightgray" } }}
                                                    onClick={() => editCrmData(row)}
                                                >
                                                    <material.TableCell>{row.crmName}</material.TableCell>
                                                    <material.TableCell>{row.clinicName ? row.clinicName : ""}</material.TableCell>
                                                    <material.TableCell sx={{ width: 400, wordWrap: "break-word", wordBreak: "break-word" }}><a href={row.website ? row.website : ""} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>{row.website ? row.website : ""}</a></material.TableCell>
                                                    <material.TableCell>{row.nurseName ? row.nurseName : ""}</material.TableCell>
                                                    <material.TableCell>{row.email ? row.email : ""}</material.TableCell>
                                                    <material.TableCell sx={{ width: 400, wordWrap: "break-word", wordBreak: "break-word" }}><a href={row.linkedin ? row.linkedin : ""} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}> {row.linkedin ? row.linkedin : ""}</a></material.TableCell>
                                                    <material.TableCell sx={{ width: 400, wordWrap: "break-word", wordBreak: "break-word" }}>{row.address ? row.address : ""}</material.TableCell>
                                                    <material.TableCell>{row.phoneNumber ? row.phoneNumber : ""}</material.TableCell>
                                                    <material.TableCell sx={{ width: 400, wordWrap: "break-word", wordBreak: "break-word" }}> <a href={row.faceBook ? row.faceBook : ""} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>{row.faceBook ? row.faceBook : ""}</a></material.TableCell>
                                                    <material.TableCell sx={{ width: 400, wordWrap: "break-word", wordBreak: "break-word" }}><a href={row.tiktok ? row.tiktok : ""} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>{row.tiktok ? row.tiktok : ""}</a></material.TableCell>
                                                    <material.TableCell sx={{ width: 400, wordWrap: "break-word", wordBreak: "break-word" }}><a href={row.instagram ? row.instagram : ""} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>{row.instagram ? row.instagram : ""}</a></material.TableCell>
                                                    <material.TableCell>{row.interested ? row.interested : ""}</material.TableCell>
                                                    {/* <material.TableCell>{row.others ? row.others : ""}</material.TableCell> */}
                                                    <material.TableCell>{row.status ? row.status : ""}</material.TableCell>
                                                    <material.TableCell>{row.nextFollowUpDate ? moment(row.nextFollowUpDate).format('YYYY-MM-DD') : ""}</material.TableCell>
                                                    <material.TableCell>{row.emailSentDate ? moment(row.emailSentDate).format('YYYY-MM-DD') : ""}</material.TableCell>
                                                    <material.TableCell>
                                                        <material.Link component="button" variant="body2" onClick={(e) => { e.stopPropagation(); viewCrmNote(row) }}>View Notes</material.Link>
                                                    </material.TableCell>
                                                </material.TableRow>
                                            )) : (
                                                <material.TableRow>
                                                    <material.TableCell colSpan={18}>
                                                        <h6 className='d-flex justify-content-center text-danger fw-bold'>No data found</h6>
                                                    </material.TableCell>
                                                </material.TableRow>
                                            )}
                                        </>
                                    )}
                                </material.TableBody>
                            </material.Table>
                        </material.TableContainer>
                        <material.TablePagination
                            rowsPerPageOptions={[5, 10, 20]}
                            component="div"
                            count={totalElements}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </material.Paper>
                </div>
            </div>
            <Snackbar
                openSnackBar={openSnackBar}
                setOpenSnackBar={setOpenSnackBar}
            />
            <AddPlatFormCrmDetails
                openAddCrm={openAddCrm}
                setOpenAddCrm={setOpenAddCrm}
                getCrmData={getCrmData}
                clinicDetails={clinicDetails}
                userDetails={userDetails}
            />
            <AddPlatFormCrm
                openEditCrm={openEditCrm}
                setOpenEditCrm={setOpenEditCrm}
                getCrmData={getCrmData}
                clinicDetails={clinicDetails}
                userDetails={userDetails}
            />
            <ViewSentMailData
                openViewSentEmail={openViewSentEmail}
                setOpenViewSentEmail={setOpenViewSentEmail}
            />
            <ViewReceiveMailData
                openViewReceiveEmail={openViewReceiveEmail}
                setOpenViewReceiveEmail={setOpenViewReceiveEmail}
            />
            <ViewNotesDialog
                openNotesDialog={openNotesDialog}
                setOpenNotesDialog={setOpenNotesDialog}
            />
        </material.Grid >
    )

}

const mapStateToProps = (state) => {
    return {
        userData: state,
        clinicData: state
    };
};
export default connect(mapStateToProps)(PlatFormCrmDetails);
